<tab-panel (onTabActivated)="trackTabActivated($event)">
	<tab id="schedule-tab" [active]="true" [name]="'APPOINTMENTS.DETAILS.BODY.TABS.SCHEDULE' | translate">
		<div class="zk-flex zk-flex-col zk-gap-6">		
			<appointment-details-session-data [event]="event"></appointment-details-session-data>
			<appointment-details-triage-data *ngIf="isScreeningSession() || event.triageId" [isFirstSession]="isFirstSession" [event]="event"></appointment-details-triage-data>
			<appointment-details-payment-data [event]="event"></appointment-details-payment-data>
			<appointment-details-tasks
				*ngIf="sessionHasTask === true"
				[task]="sessionTask"
			></appointment-details-tasks>
			<appointment-details-alert [event]="event"></appointment-details-alert>	
		</div>
	</tab>
	<tab id="history-tab" [name]="'APPOINTMENTS.DETAILS.BODY.TABS.HISTORY' | translate">
		<appointment-details-historic-tab [contactId]="contact?.refUserId"></appointment-details-historic-tab>
	</tab>
</tab-panel>